const SDK_DOMAIN_NAME = "intrack.ir";

class DeviceId {
  constructor() {
    this.device_id_;
  }

  getUniqId() {
    const dvId = localStorage.getItem("device_id");
    if (dvId) {
      return dvId;
    } else {
      let d = new Date().getTime();
      const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    }
  }

  store(type, value) {
    if (!value) return this.getUniqId();

    switch (type) {
      case "int_id":
        localStorage.setItem("device_id", value);
        break;
      case "int_queue":
        this.device_id_ = value;
        break;
    }
  }

  injectDeviceIframe() {
    if (this.deviceFrameInjected) return;

    if (!document.getElementById("intk-device-frame")) {
      this.deviceFrameInjected = true;
      const iframe = document.createElement("iframe");
      iframe.setAttribute("id", "intk-device-frame");
      iframe.setAttribute(
        "style",
        "display: none !important; width: 0px !important; height: 0px !important; opacity: 0 !important; pointer-events: none !important;"
      );
      iframe.src = `https://static1.${SDK_DOMAIN_NAME}/api/web/download/sdk/device.html`;
      document.body.appendChild(iframe);
    }

    const deviceFrame = document.getElementById("intk-device-frame");
    const devId = this.store("int_id");
    deviceFrame.onload = function () {
      deviceFrame.contentWindow.postMessage(
        {
          deviceId: devId,
          source: "intk",
        },
        "*"
      );
    };
  }

  receiveMessage() {
    if (window.postMessage) {
      this.injectDeviceIframe();
      const self = this;
      this.device_id = this.device_id || "[aff]_tmp_device_id";
      let requestQueue = [];

      const promise = new Promise((resolve, reject) => {
        window.addEventListener(
          "message",
          (event) => {
            if (event.origin !== `https://static1.${SDK_DOMAIN_NAME}`) {
              resolve(true);
              return;
            }

            if (
              event.data.constructor.toString().indexOf("Object") > -1 &&
              event.data.deviceId &&
              event.data.source === "intk"
            ) {
              const evId = event.data.deviceId;
              self.device_id = event.data.deviceId;
              self.store("int_id", event.data.deviceId);
              resolve(evId);

              requestQueue.forEach((req) => {
                if (req.deviceId === "[aff]_tmp_device_id") {
                  req.deviceId = self.device_id;
                }
              });

              self.store("int_queue", requestQueue, true);
            }
          },
          false
        );
        setTimeout(() => {
          const isExist = localStorage.getItem("device_id");
          resolve(true);
        }, 2000);
      });

      return promise;
    } else {
      this.device_id = this.getUniqId();
      self.store("int_id", this.device_id);
      requestQueue.forEach((req) => {
        if (req.deviceId === "[aff]_tmp_device_id") {
          req.deviceId = self.device_id;
        }
      });
      self.store("int_queue", requestQueue, true);
    }
  }
}
const DeviceId_ = new DeviceId();

export default DeviceId_;
